import { useCallback, useEffect, useState } from "react";
import {
  STORAGE_KEY_ACCESS_TOKEN,
  STORAGE_KEY_LOGGED_USER,
} from "@/constants/constants";

function useTokenAndUserState() {
  const [initialized, setInitialized] = useState(false);
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  const clearState = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY_LOGGED_USER);
    localStorage.removeItem(STORAGE_KEY_ACCESS_TOKEN);
    setUser(null);
    setAccessToken(null);
  }, []);

  const setUserInstance = useCallback((userValue) => {
    if (!userValue) {
      clearState();
      return;
    }

    localStorage.setItem(STORAGE_KEY_LOGGED_USER, JSON.stringify(userValue));
    setUser(userValue);
  }, []);

  const setAccessTokenInstance = useCallback((accessTokenValue) => {
    if (!accessTokenValue) {
      clearState();
    } else {
      localStorage.setItem(STORAGE_KEY_ACCESS_TOKEN, accessTokenValue);
      setAccessToken(accessTokenValue);
    }
  }, []);

  useEffect(() => {
    const storedAccessToken = localStorage.getItem(STORAGE_KEY_ACCESS_TOKEN);
    const storedUser = localStorage.getItem(STORAGE_KEY_LOGGED_USER);

    if (!storedAccessToken || !storedUser) {
      clearState();
    } else {
      try {
        setUser(JSON.parse(storedUser));
        setAccessToken(storedAccessToken);
      } catch (e) {
        clearState();
      }
    }

    setInitialized(true);
  }, []);

  return {
    initialized: initialized,
    setInitialized: setInitialized,
    user: user,
    setUser: setUserInstance,
    accessToken: accessToken,
    setAccessToken: setAccessTokenInstance,
    clearState: clearState,
  };
}

export default useTokenAndUserState;
